<template>
  <div class="aboutA">
    <h2>关于我们</h2>
    <div class="wrap">
            <span>
                彩虹律师作为新一代的互联网化的法律服务机构，能为公司客户在日常经营、公司治理和商业活动提供广泛的高级法律服务。我们的高级律师合
伙人团队，不仅处理交易过程中的各个方面问题，包括繁杂的审批程序、结构性投资、谈判、 起草所需的文件、尽职调查，也对客户日常经营中
出现的法律、行政和监管问题提供法律服务。彩虹律师在私募股权投资、风险投资、投资基金、非上市公司的融资等法律业务领域具有良好的经验，能协助私募股权基金、战略投资者、风险投资机构、天使投资人和国内创业者与企业，完成不同行业领域投融资项目。我们服务内容包括尽职调查、融资框架设计、投资协议和相关各类合同的审阅、协助客户进行政府审批等。
            </span>
    </div>
    <div class="footer">
      <div class="con">
        <div class="conleft">
          <div class="conleftOne">
            <i></i>
            <p>关于彩虹律师高端服务</p>
          </div>
          <div class="conleftTwo">
                        <span>彩虹律师高端服务于2018-8-8正式上线
                            <br>
                            由15年-20年行业资深律师组成彩虹律师
                            <br>
                            高级合伙人团队
                        </span>
          </div>
          <div class="conleftThr">
            <a href="https://www.ch64.cn">彩虹律师首页</a>
          </div>
        </div>
        <div class="conright">
          <div class="conrightOne">
            <i></i>
            <p>联系我们</p>
          </div>
          <div class="conrightTwo">
            <i></i>
            <p>400-108-4008</p>
          </div>
          <div class="conYoux">
            <i></i>
            <p>tousu@ch64.cn</p>
          </div>
          <div class="conrightThr">
            <i></i>
            <p>上海市威海路228号招商局广场北楼10楼</p>
          </div>
        </div>
        <div class="conQr">
          <div class="conQrT">
            <i></i>
            <p>关注我们</p>
          </div>
          <div class="conQrB">
            <img src="../assets/img/微信二维码.png" alt="">
          </div>
        </div>
        <div class="conBottom">
          <span>Copyright © 2013-2023 上海九加信息科技有限公司 All Right Reserved. 沪 ICP 备 14047255 号-3</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about"
}
</script>

<style lang="less" scoped>
.aboutA {
  width: 100%;
  height: 800px;
  background: rgb(248, 248, 248);
  position: relative;

  h2 {
    padding-top: 80px;
    font-size: 30px;
    color: rgb(43, 43, 43);
    padding-bottom: 36px;
    text-align: center;
  }

  .wrap {
    width: 1100px;
    height: 250px;
    background: rgb(255, 255, 255);
    box-shadow: 0 5px 21px 0 rgba(3, 20, 58, 0.14);
    margin: 0 auto;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */

    span {
      padding-left: 76px;
      padding-right: 76px;
      font-size: 16px;
      line-height: 32px;
    }
  }

  .footer {
    width: 100%;
    height: 280px;
    position: absolute;
    bottom: 0;
    left: 0;
    background: rgb(41, 44, 49);

    .con {
      padding-top: 40px;
      width: 1100px;
      height: 240px;
      margin: 0 auto;
      /*background: yellowgreen;*/

      .conleft {
        width: 470px;
        height: 200px;
        float: left;
        color: white;

        .conleftOne {
          position: relative;

          i {
            display: inline-block;
            width: 3px;
            height: 20px;
            background: rgb(50, 150, 250);
            text-align: center;
          }

          p {
            position: absolute;
            top: 0;
            left: 20px;
            display: inline-block;
            font-size: 20px;
            line-height: 20px;
            text-align: center;
          }
        }

        .conleftTwo {
          span {
            padding-top: 30px;
            display: block;
            font-size: 14px;
            line-height: 25px;
            width: 263px;
          }
        }

        .conleftThr {
          padding-top: 30px;

          a {

            font-size: 14px;
            line-height: 25px;
            color: rgb(50, 150, 250);
          }
        }
      }

      .conright {
        width: 470px;
        height: 200px;
        float: left;
        color: white;

        .conrightOne {
          position: relative;

          i {
            display: inline-block;
            width: 3px;
            height: 20px;
            background: rgb(50, 150, 250);
            text-align: center;
          }

          p {
            position: absolute;
            top: 0;
            left: 20px;
            display: inline-block;
            font-size: 20px;
            line-height: 20px;
            text-align: center;
          }
        }

        .conrightTwo {
          padding-top: 30px;
          position: relative;

          i {
            display: inline-block;
            width: 14px;
            height: 14px;
            background: url("../assets/img/电话.png");
          }

          p {
            position: absolute;
            top: 25px;
            left: 40px;
            display: inline-block;
            font-size: 14px;
            line-height: 25px;
            text-align: center;
          }
        }

        .conrightThr {
          padding-top: 30px;
          position: relative;

          i {
            display: inline-block;
            width: 11px;
            height: 14px;
            background: url("../assets/img/adress.png");
          }

          p {
            position: absolute;
            top: 25px;
            left: 40px;
            display: inline-block;
            font-size: 14px;
            line-height: 25px;
            text-align: center;
          }
        }

        .conYoux {
          padding-top: 30px;
          position: relative;

          i {
            display: inline-block;
            width: 12px;
            height: 9px;
            background: url("../assets/img/邮箱.png");
          }

          p {
            position: absolute;
            top: 25px;
            left: 40px;
            display: inline-block;
            font-size: 14px;
            line-height: 25px;
            text-align: center;
          }
        }
      }

      .conQr {
        float: left;
        width: 160px;
        height: 200px;

        .conQrT {
          color: rgb(232, 232, 232);
          position: relative;

          i {
            display: inline-block;
            width: 3px;
            height: 20px;
            background: rgb(50, 150, 250);
            text-align: center;
          }

          p {
            position: absolute;
            top: 0;
            left: 20px;
            display: inline-block;
            font-size: 20px;
            line-height: 20px;
            text-align: center;
          }
        }

        .conQrB {
          padding-top: 30px;

          img {
            width: 100px;
            height: 100px;
          }
        }
      }

      .conBottom {
        width: 100%;
        height: 40px;
        /*background: white;*/
        float: left;
        text-align: center;

        span {
          font-size: 14px;
          line-height: 40px;
          color: rgb(232, 232, 232);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue